exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-module__container___3JAua {\n  position: fixed;\n  width: 100%;\n  display: block;\n  background: #EBEBEB;\n  opacity: 0.7;\n  z-index: 5;\n  top: 0;\n  bottom: 0;\n}\n\n.index-module__inner-container___UxESa {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  margin-top: 104px;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "index-module__container___3JAua",
	"inner-container": "index-module__inner-container___UxESa",
	"innerContainer": "index-module__inner-container___UxESa"
};